import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { BRAND } from "./data/content";

// Warm up the image CDN and fetch the above-the-fold artwork as early as possible.
const head = document.head;
const preconnect = document.createElement("link");
preconnect.rel = "preconnect";
preconnect.href = "https://cdn.magicpatterns.com";
preconnect.crossOrigin = "anonymous";
head.appendChild(preconnect);
[BRAND.logoUrl, BRAND.bannerUrl].forEach(href => {
  const preload = document.createElement("link");
  preload.rel = "preload";
  preload.as = "image";
  preload.href = href;
  head.appendChild(preload);
});
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-351" data-mp="2p1uy8nhgj2p2" />);
}